/* ============================================================
 * StoreCRM お気に入り機能（StoreCRM追加ファイル）
 * お気に入り一覧ページ（/apps/obake/favorites）のスタイル上書き。
 * StoreCRM配信のHTML/CSSをテーマ側からJSで補正する。
 * テーマ更新時はこのファイルごと保持すること。
 * ============================================================ */
(function () {
  // /apps/obake/favorites およびそのサブパス・末尾スラッシュ違いに対応
  if (!window.location.pathname.startsWith('/apps/obake/favorites')) return;

  // 実体のHTMLは storecrm/backend/app/api/auth/shopify.py:favorite_list() が配信し、
  // 商品行は storecrm.js が tbody に動的に挿入する。クラス名は .storecrm_favoritelist 系。

  // PC/SP 共通の調整
  function applyCommonStyles(list) {
    // タイトル（または直前の要素）と商品テーブルの間に余白
    var table = list.querySelector('table');
    if (table) {
      table.style.setProperty('margin-top', '1rem', 'important');
    }
  }

  // PC/SP 共通: 画像と商品名を横並びにして、商品名が画像下へ回り込むのを防ぐ
  function applyRowLayout(list) {
    var isMobile = window.innerWidth < 700;
    var lefttds = list.querySelectorAll('.storecrm_favoritelist_lefttd');

    lefttds.forEach(function (cell) {
      if (isMobile) {
        // SPでは左セルを自動幅にして、右セルの削減分まで商品名に使わせる
        cell.style.setProperty('width', 'auto', 'important');
      }

      var wrapper = cell.querySelector(':scope > .storecrm_flex_wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'storecrm_flex_wrapper';
        while (cell.firstChild) {
          wrapper.appendChild(cell.firstChild);
        }
        cell.appendChild(wrapper);
      }
      wrapper.style.setProperty('display', 'flex', 'important');
      wrapper.style.setProperty('align-items', 'center', 'important');
      wrapper.style.setProperty('gap', '0.5rem', 'important');

      var img = wrapper.querySelector('.storecrm_favoritelist_img');
      if (img) {
        img.style.setProperty('margin-right', '0', 'important');
        img.style.setProperty('flex-shrink', '0', 'important');
      }

      var anchors = wrapper.querySelectorAll(':scope > a');
      anchors.forEach(function (a) {
        if (a.querySelector('img')) {
          a.style.setProperty('flex-shrink', '0', 'important');
        } else {
          a.style.setProperty('flex', '1 1 0', 'important');
          a.style.setProperty('min-width', '0', 'important');

          if (isMobile) {
            // SPでは商品名を3行で省略し、長い文字列でもセル外へはみ出さないようにする
            a.style.setProperty('display', '-webkit-box', 'important');
            a.style.setProperty('-webkit-box-orient', 'vertical', 'important');
            a.style.setProperty('-webkit-line-clamp', '3', 'important');
            a.style.setProperty('line-clamp', '3', 'important');
            a.style.setProperty('overflow', 'hidden', 'important');
            a.style.setProperty('word-break', 'break-all', 'important');
            a.style.removeProperty('overflow-wrap');
          } else {
            // PCでは省略せず、長い商品名だけ任意位置で折り返す
            a.style.setProperty('overflow-wrap', 'anywhere', 'important');
            a.style.removeProperty('display');
            a.style.removeProperty('-webkit-box-orient');
            a.style.removeProperty('-webkit-line-clamp');
            a.style.removeProperty('line-clamp');
            a.style.removeProperty('overflow');
            a.style.removeProperty('word-break');
          }
        }
      });
    });
  }

  // SP表示時のみの調整
  function applyMobileStyles(list) {
    if (window.innerWidth >= 700) return;

    // var(--xxx) を setProperty に渡すと変数解決に失敗するケースがあるため、実値を取得
    var rootStyle = getComputedStyle(document.documentElement);
    var textH4 = rootStyle.getPropertyValue('--text-h4').trim() || '1rem';
    var textH5 = rootStyle.getPropertyValue('--text-h5').trim() || '0.875rem';
    var gutter = rootStyle.getPropertyValue('--container-gutter').trim() || '1.25rem';

    // ラッパー全体に左右余白
    list.style.setProperty('padding-left', gutter, 'important');
    list.style.setProperty('padding-right', gutter, 'important');
    list.style.setProperty('box-sizing', 'border-box', 'important');

    // タイトル「お気に入り一覧」
    var title = list.querySelector('h1');
    if (title) {
      title.style.setProperty('font-size', textH4, 'important');
      title.style.setProperty('line-height', '1.6', 'important');
    }

    // 空状態 / ローディング表示
    var emptyMessage = list.querySelector('.storecrm_favoritelist_non_item');
    if (emptyMessage) {
      emptyMessage.style.setProperty('font-size', textH5, 'important');
      emptyMessage.style.setProperty('line-height', '1.7', 'important');
    }
    var loading = list.querySelector('.storecrm_favoritelist_loading');
    if (loading) {
      loading.style.setProperty('font-size', textH5, 'important');
      loading.style.setProperty('line-height', '1.7', 'important');
    }

    // 右セル: 必要最小幅まで縮めて、× ボタンの右余白を 0.5rem に
    var righttds = list.querySelectorAll('.storecrm_favoritelist_righttd');
    righttds.forEach(function (cell) {
      cell.style.setProperty('width', '1%', 'important');
      cell.style.setProperty('white-space', 'nowrap', 'important');
      cell.style.setProperty('padding-right', '0.5rem', 'important');
    });
    var linksDivs = list.querySelectorAll('.storecrm_favoritelist_links');
    linksDivs.forEach(function (div) {
      div.style.setProperty('padding-right', '0', 'important');
    });
  }

  function applyAll() {
    var list = document.querySelector('.storecrm_favoritelist');
    if (!list) return;
    applyCommonStyles(list);
    applyRowLayout(list);
    applyMobileStyles(list);
  }

  function init() {
    applyAll();

    // StoreCRM JS が商品行を非同期で挿入するため、追加・差し替えに追従する
    var list = document.querySelector('.storecrm_favoritelist');
    if (list && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        applyAll();
      });
      observer.observe(list, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
